import React from "react";
import GridContainer from "Components/Grids/grid-container";
import ProductList from "./product-list";
import { useTranslation } from "react-i18next";

const ProductListContainer: () => JSX.Element
    = (): JSX.Element => {
        const { t } = useTranslation(["commonResources"]);

        return (
            <React.Fragment>
                <GridContainer title={t("productForm.listTitle")} >
                    <ProductList adminMode={true} />
                </GridContainer>
            </React.Fragment>
        );
    };

export default ProductListContainer;